
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 368 368","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m360 160h-8v-152c0-4.425781-3.574219-8-8-8s-8 3.574219-8 8v24h-32v-24c0-4.425781-3.574219-8-8-8s-8 3.574219-8 8v24h-32v-24c0-4.425781-3.574219-8-8-8s-8 3.574219-8 8v24h-32v-24c0-4.425781-3.574219-8-8-8h-192c-4.425781 0-8 3.574219-8 8v352c0 4.425781 3.574219 8 8 8h352c4.425781 0 8-3.574219 8-8v-192c0-4.425781-3.574219-8-8-8zm-56 0v-48h32v48zm-48 0v-48h32v48zm-48 0v-48h32v48zm128-112v48h-32v-48zm-48 0v48h-32v-48zm-48 0v48h-32v-48zm-48-32v152c0 4.425781 3.574219 8 8 8h152v112h-336v-272zm-176 336v-48h336v48zm0 0"}})])
          )
        }
      }
    